import { render, staticRenderFns } from "./MainGuest.vue?vue&type=template&id=3a5bf734"
import script from "./MainGuest.vue?vue&type=script&lang=js"
export * from "./MainGuest.vue?vue&type=script&lang=js"
import style0 from "./MainGuest.vue?vue&type=style&index=0&id=3a5bf734&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports